import { apiGetJSON } from "../../client.js";
import {
  normalizeThreadDiagnostics,
  normalizeWorkspaceDiagnostics
} from "../../domain/diagnostics.js";

export async function enrichHarnessThreadSnapshot(apiKey, snapshot, threadID, signal) {
  const [threadDiagnostics, workspaceDiagnostics] = await Promise.all([
    apiGetJSON(apiKey, `/v1/threads/${encodeURIComponent(threadID)}/diagnostics`, { signal }),
    snapshot?.thread?.workspace_id
      ? apiGetJSON(apiKey, `/v1/workspaces/${encodeURIComponent(snapshot.thread.workspace_id)}/diagnostics`, { signal })
      : Promise.resolve(null)
  ]);
  return {
    ...snapshot,
    threadDiagnostics: normalizeThreadDiagnostics(threadDiagnostics),
    workspaceDiagnostics: workspaceDiagnostics ? normalizeWorkspaceDiagnostics(workspaceDiagnostics) : null
  };
}
